// store/userSlice.ts
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { apiRequest, deleteItem, fetchData, handleAddItem, handleUpdateItem } from '../../utils/data';
import { CreditCardType, Notification, PaginationType, UserType } from '../../types';

interface State {
  users: UserType[]
  user: UserType | null;
  creditCards: CreditCardType[];
  notifications: Notification[];
  pagination: PaginationType | null
  notificationCount: any;
  loading: boolean
  isEditing: boolean;
}
//function to get user by id
export const fetchUser = createAsyncThunk("get/user", async (id: string | number) => {
  const data = await fetchData(`Profile/getProfileData?UserID=${id}`, true);
  return data;
});
//delete account
export const deleteAccount = createAsyncThunk("delete/user", async (id: string | number) => {
  await deleteItem(`Authentication/deleteUser?userId=`, id);
  return id;
});
//function to get users
export const fetchUsers = createAsyncThunk("get/users", async () => {
  const data = await fetchData(`Authentication/getUsers`, true);
  return data;
});
export const updateUser = createAsyncThunk("PUT/user", async (data: any) => {
  await handleUpdateItem(data, `Profile/editProfileData`, "PUT");
  return { ...data };
});
export const editPhoneNumber = createAsyncThunk("PUT/editPhoneNumber", async ({ userId, phoneNumber }: any) => {
  const data = await handleUpdateItem("", `Profile/editPhoneNumber?UserID=${userId}&phoneNumber=${phoneNumber}`, "PUT");
  return data;
});
export const fetchNotifications = createAsyncThunk("/Notification", async ({ userId, page }: { userId: string | number, page: number }) => {
  const data = await fetchData(`Notification/getNotifications?userId=${userId}&page=${page}`, true, true);
  return data;
});
export const fetchNumberOfUnreadNotifications = createAsyncThunk("/NumberOfUnreadNotifications", async (userId: string | number) => {
  const data = await fetchData(`Notification/getNumberOfUnreadNotifications?userId=${userId}`, true);
  return data;
});
export const markAllNotificationsRead = createAsyncThunk("/markAllNotificationsRead", async (userId: string | number) => {
  try {
    const response = await apiRequest(`Notification/markAllNotificationsRead?userId=${userId}`, {
      method: "POST",
      auth: true
    });

    return response
  } catch (error: any) {
    return null;
  }
});
//////////////////////////////////////
//functions for get cards of user////
////////////////////////////////////
export const fetchCreditCard = createAsyncThunk("get/CreditCard", async (userId: string | number) => {
  const data = await fetchData(`CreditCard/getCreditCard?userId=${userId}`, true);
  return data;
});

export const addCreditCard = createAsyncThunk("post/CreditCard", async (CreditCardData: any) => {
  await handleAddItem(CreditCardData, "CreditCard/addCreditCard", "POST");
  return CreditCardData;
});
export const updateCreditCard = createAsyncThunk("PUT/CreditCard", async ({ id, data }: { id: number, data: any }) => {
  await handleUpdateItem(data, `CreditCard/updateCreditCard?cardId=${id}`, "PUT");

});
export const deleteCreditCard = createAsyncThunk("delete/CreditCard", async ({ cardId, userId }: { cardId: number, userId: string | number }) => {
  await deleteItem(`CreditCard/deleteCreditCard?cardId=${cardId}&userId=`, userId);
});

const initialState: State = {
  users: [],
  user: null,
  notifications: [],
  pagination: null,
  creditCards: [],
  notificationCount: null,
  loading: false,
  isEditing: false
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserType>) => {
      state.user = action.payload;
    },
    clearUser: (state) => {
      state.user = null;
    },
    startEditing: (state) => {
      state.isEditing = true;
    },
    stopEditing: (state) => {
      state.isEditing = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(fetchNotifications.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchNumberOfUnreadNotifications.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchNumberOfUnreadNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notificationCount = action.payload;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
      })
      .addCase(fetchCreditCard.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchCreditCard.fulfilled, (state, action) => {
        state.loading = false;
        state.creditCards = action.payload;
      })


  }
});

export const { setUser, clearUser, startEditing, stopEditing } = userSlice.actions;
export default userSlice.reducer;
